import client from "./client";

export default {

    async getPropertySettings(filters) {
        return client.parseResponse(await client.get('/property-settings', filters));
    },
    async getPropertySetting(id) {
        return client.parseResponse(await client.get('/property-settings/' + id));
    },
    async createPropertySetting(data) {
        return client.parseResponse(await client.post('/property-settings', data))
    },
    async editPropertySetting(data) {
        return client.parseResponse(await client.put('/property-settings/' + data.id, data))
    },
    async deletePropertySetting(data) {
        return client.parseResponse(await client.delete('/property-settings/' + data.id, data))
    }
}
